import script from "./policyMent.vue?vue&type=script&setup=true&lang=ts"
export * from "./policyMent.vue?vue&type=script&setup=true&lang=ts"

import "./policyMent.vue?vue&type=style&index=0&id=b98df20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b98df20c"]])

export default __exports__